import {
  Box,
  Button,
  Container,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import { useContext, useRef } from 'react';
import { useQueryClient } from 'react-query';
import { BANK_ACCOUNTS_KEY } from '../../api/hooks/cache-keys';
import { useCreateBankAccount, useGetFirms } from '../../api/hooks/sales';
import { ModalContext } from '../../contexts/modal';
import { ToastContext } from '../../contexts/toast';

function NewBankAccountForm() {
  const bankRef = useRef();
  const ownerRef = useRef();
  const cardNumber = useRef();
  const shebaRef = useRef();
  const branchRef = useRef();
  const accountNumberRed = useRef();
  const branchCodeRef = useRef();
  const createAccount = useCreateBankAccount();
  const { setOpen } = useContext(ModalContext);
  const { showToast } = useContext(ToastContext);
  const queryClient = useQueryClient();
  const { data: subsidaries } = useGetFirms(true);

  async function onClick() {
    try {
      await createAccount.mutateAsync({
        bank: bankRef.current.value,
        branchName: branchRef.current.value,
        branchCode: branchCodeRef.current.value,
        accountNumber: accountNumberRed.current.value,
        cardNumber: cardNumber.current.value,
        shebaNumber: shebaRef.current.value,
        owner: ownerRef.current.value,
      });
      await queryClient.invalidateQueries(BANK_ACCOUNTS_KEY());
      showToast('حساب جدید ساخته شد.', 'success');
      setOpen(false);
    } catch (e) {
      console.log(e);
    }
  }

  return (
    <Container maxWidth="md">
      <form autoComplete={false}>
        <FormControl variant="filled" size="small" fullWidth>
          <InputLabel>صاحب حساب</InputLabel>
          <Select fullWidth label="حقیقی/حقوقی" placeholder="حقیقی/حقوقی" inputRef={ownerRef}>
            {subsidaries.map((s) => (
              <MenuItem value={s.id} key={s.id}>
                {s.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Box sx={{ my: 2 }}>
          <TextField
            label="بانک"
            variant="filled"
            size="small"
            type="numeric"
            fullWidth
            inputRef={bankRef}
          />
        </Box>

        <Box sx={{ my: 2 }}>
          <TextField
            label="شماره‌حساب"
            variant="filled"
            size="small"
            type="numeric"
            fullWidth
            inputRef={accountNumberRed}
          />
        </Box>

        <Box sx={{ my: 2 }}>
          <TextField
            label="شعبه"
            variant="filled"
            size="small"
            type="numeric"
            fullWidth
            inputRef={branchRef}
          />
        </Box>

        <Box sx={{ my: 2 }}>
          <TextField
            label="کد شعبه"
            variant="filled"
            size="small"
            type="numeric"
            fullWidth
            inputRef={branchCodeRef}
          />
        </Box>

        <Box sx={{ my: 2 }}>
          <TextField
            label="شماره شبا"
            variant="filled"
            size="small"
            type="numeric"
            fullWidth
            inputRef={shebaRef}
          />
        </Box>
        <Box sx={{ my: 2 }}>
          <TextField
            label="شماره کارت"
            variant="filled"
            size="small"
            type="numeric"
            fullWidth
            inputRef={cardNumber}
          />
        </Box>
        <Button variant="contained" color="primary" sx={{ mb: 4 }} fullWidth onClick={onClick}>
          ایجاد
        </Button>
      </form>
    </Container>
  );
}

export default NewBankAccountForm;
